import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientStats = ({ stats, className = "" }) => {
  const statCards = [
    {
      title: 'Total Clients',
      value: stats?.totalClients || 0,
      change: stats?.clientsChange,
      changeType: stats?.clientsChange >= 0 ? 'positive' : 'negative',
      icon: 'Users',
      color: 'primary'
    },
    {
      title: 'Active Clients',
      value: stats?.activeClients || 0,
      change: stats?.activeChange,
      changeType: stats?.activeChange >= 0 ? 'positive' : 'negative',
      icon: 'UserCheck',
      color: 'success'
    },
    {
      title: 'New This Month',
      value: stats?.newThisMonth || 0,
      change: stats?.newChange,
      changeType: stats?.newChange >= 0 ? 'positive' : 'negative',
      icon: 'UserPlus',
      color: 'accent'
    },
    {
      title: 'Inactive Clients',
      value: stats?.inactiveClients || 0,
      change: stats?.inactiveChange,
      changeType: stats?.inactiveChange >= 0 ? 'negative' : 'positive',
      icon: 'UserX',
      color: 'destructive'
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return 'bg-primary/10 text-primary';
      case 'success':
        return 'bg-success/10 text-success';
      case 'accent':
        return 'bg-accent/10 text-accent';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'destructive':
        return 'bg-red-50 text-red-600';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getChangeColor = (changeType) => {
    return changeType === 'positive' ? 'text-success' : 'text-error';
  };

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ${className}`}>
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card rounded-lg border border-border p-6 hover:shadow-elevation-2 transition-all duration-200">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(stat?.color)}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            
            {stat?.change !== undefined && (
              <div className={`flex items-center space-x-1 text-sm font-medium ${getChangeColor(stat?.changeType)}`}>
                <Icon 
                  name={stat?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                  size={16} 
                />
                <span>{Math.abs(stat?.change)}%</span>
              </div>
            )}
          </div>
          
          <div>
            <div className="text-2xl font-bold text-foreground mb-1">
              {stat?.value?.toLocaleString()}
            </div>
            <div className="text-sm text-muted-foreground">
              {stat?.title}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientStats;